(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comparison-help"]) return;
  try {
    
(function () {
  function openZendeskChat() {
    try {
      if (typeof window.zE === 'function') {
        try { window.zE('messenger', 'open'); return; } catch (error) {}
        try { window.zE('webWidget', 'open'); return; } catch (error) {}
        try { window.zE('webWidget', 'chat:send', ''); window.zE('webWidget', 'open'); return; } catch (error) {}
      }
      if (window.$zopim && window.$zopim.livechat && window.$zopim.livechat.window) {
        window.$zopim.livechat.window.show();
        return;
      }
      var launcher = document.querySelector('[aria-label*="chat" i], [class*="zEWidget"], iframe[title*="chat" i], iframe[title*="messag" i]');
      if (launcher && typeof launcher.click === 'function') launcher.click();
    } catch (error) {}
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target && event.target.closest && event.target.closest('.comparison-help [data-open-zendesk-chat]');
    if (!trigger) return;
    event.preventDefault();
    openZendeskChat();
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deals-collection-template"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-deals-read-more]');

    sections.forEach(function (section) {
      var content = section.querySelector('[data-deals-read-more-content]');
      var toggle = section.querySelector('[data-deals-read-more-toggle]');

      if (!content || !toggle) {
        return;
      }

      if (content.scrollHeight <= content.clientHeight + 8) {
        section.classList.add('is-short');
        return;
      }

      toggle.addEventListener('click', function () {
        var expanded = section.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        toggle.textContent = expanded ? 'Read Less' : 'Read More';
      });
    });

    document.addEventListener('click', function (event) {
      var launcher = event.target.closest && event.target.closest('[data-deals-chat-launch]');
      if (!launcher) return;

      if (typeof window.zE === 'function') {
        window.zE('webWidget', 'open');
        return;
      }

      var zendeskLauncher = document.querySelector('iframe#launcher');
      if (zendeskLauncher && zendeskLauncher.contentWindow) {
        try {
          zendeskLauncher.contentWindow.focus();
        } catch (error) {}
      }
    });

    function reviewNumberFromText(text) {
      if (!text) return 0;
      var match = text.replace(/,/g, '').match(/\d+/);
      return match ? parseInt(match[0], 10) : 0;
    }

    function syncDealsReviewCounts() {
      var rows = document.querySelectorAll('[data-deals-review-row]');

      rows.forEach(function (row) {
        var customCount = reviewNumberFromText(row.getAttribute('data-custom-review-count'));
        var yotpoMetafieldCount = reviewNumberFromText(row.getAttribute('data-yotpo-review-count'));
        var yotpoBadge = row.querySelector('.shopify-product-reviews-badge');
        var yotpoCount = reviewNumberFromText(yotpoBadge ? yotpoBadge.textContent : '');
        var total = customCount + Math.max(yotpoMetafieldCount, yotpoCount);
        var totalNode = row.querySelector('[data-deals-total-reviews]');

        if (!totalNode || total <= 0) return;
        totalNode.textContent = total.toLocaleString();
        row.classList.add('has-review-count');
      });
    }

    [250, 750, 1500, 3000, 6000, 10000].forEach(function (delay) {
      window.setTimeout(syncDealsReviewCounts, delay);
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["google-ads-mattress-landing"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-nb-landing]').forEach(function (landing) {
    var choices = landing.querySelectorAll('[data-nb-choice]');
    var products = landing.querySelectorAll('[data-nb-product]');
    var status = landing.querySelector('[data-nb-status]');
    choices.forEach(function (choice) {
      choice.addEventListener('click', function () {
        var selected = choice.getAttribute('data-nb-choice');
        choices.forEach(function (button) { button.setAttribute('aria-pressed', button === choice ? 'true' : 'false'); });
        products.forEach(function (product) { product.classList.toggle('is-recommended', product.getAttribute('data-nb-product') === selected); });
        var target = landing.querySelector('[data-nb-product="' + selected + '"]');
        if (target) {
          status.textContent = target.querySelector('h3').textContent + landing.getAttribute('data-result-suffix');
          target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
          target.focus({ preventScroll: true });
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["google-ads-pillow-landing"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-nb-pillow]').forEach(function (landing) {
    var choices = landing.querySelectorAll('[data-pillow-choice]');
    var products = landing.querySelectorAll('[data-pillow-product]');
    var status = landing.querySelector('[data-pillow-status]');
    choices.forEach(function (choice) {
      choice.addEventListener('click', function () {
        var selected = choice.getAttribute('data-pillow-choice');
        choices.forEach(function (button) { button.setAttribute('aria-pressed', button === choice ? 'true' : 'false'); });
        products.forEach(function (product) { product.classList.toggle('is-recommended', product.getAttribute('data-pillow-product') === selected); });
        var target = landing.querySelector('[data-pillow-product="' + selected + '"]');
        if (target) {
          status.textContent = target.querySelector('h3').textContent + landing.getAttribute('data-result-suffix');
          target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'center' });
          target.focus({ preventScroll:true });
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mattress-history-timeline"]) return;
  try {
    
  (function () {
    var root = document.querySelector('.mattress-history');
    if (!root) return;

    root.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var id = link.getAttribute('href');
        var target = id && document.querySelector(id);
        if (!target) return;
        event.preventDefault();
        var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nest-blog-discovery"]) return;
  try {
    
(function(){var roots=document.querySelectorAll('[data-nest-blog]');roots.forEach(function(root){var input=root.querySelector('[data-nest-search-input]');var field=root.querySelector('.nest-blog-search__field');var box=root.querySelector('[data-nest-suggestions]');var status=root.querySelector('[data-nest-status]');var timer;var keyboardFocus=false;function announce(message){if(!status)return;status.textContent='';window.setTimeout(function(){status.textContent=message},20)}document.addEventListener('keydown',function(event){if(event.key==='Tab')keyboardFocus=true},true);document.addEventListener('pointerdown',function(){keyboardFocus=false;if(field)field.classList.remove('nest-blog-search__field--keyboard-focus')},true);if(input&&field){input.addEventListener('focus',function(){field.classList.toggle('nest-blog-search__field--keyboard-focus',keyboardFocus)});input.addEventListener('blur',function(){field.classList.remove('nest-blog-search__field--keyboard-focus')})}if(input&&box){input.addEventListener('input',function(){clearTimeout(timer);var q=input.value.trim();if(q.length<2){box.hidden=true;box.innerHTML='';return}timer=setTimeout(function(){var url=root.dataset.predictiveUrl+'?q='+encodeURIComponent(q)+'&resources[type]=article,page&resources[limit]=8&resources[options][unavailable_products]=hide';fetch(url,{headers:{Accept:'application/json'}}).then(function(r){return r.json()}).then(function(data){var results=data.resources&&data.resources.results?data.resources.results:{};var items=[];(results.articles||[]).forEach(function(item){items.push({label:'Article',title:item.title,url:item.url})});(results.pages||[]).forEach(function(item){items.push({label:'Guide',title:item.title,url:item.url})});box.innerHTML='';items.slice(0,8).forEach(function(item){var a=document.createElement('a');a.href=item.url;var type=document.createElement('span');type.textContent=item.label;var title=document.createElement('strong');title.textContent=item.title;a.appendChild(type);a.appendChild(title);box.appendChild(a)});box.hidden=!items.length}).catch(function(){box.hidden=true;announce('Search suggestions are temporarily unavailable.')})},220)});input.addEventListener('keydown',function(event){if(event.key==='Escape'){box.hidden=true;box.innerHTML='';input.focus()}});document.addEventListener('click',function(e){if(!root.contains(e.target)){box.hidden=true}})}

function updateFilterState(doc){var active=doc.querySelector('[data-nest-filter][aria-current="page"]');var activeUrl=active?new URL(active.href,window.location.origin).pathname:'';root.querySelectorAll('[data-nest-filter]').forEach(function(link){var path=new URL(link.href,window.location.origin).pathname;if(activeUrl&&path===activeUrl){link.setAttribute('aria-current','page')}else{link.removeAttribute('aria-current')}})}
function loadResults(url,pushState,moveFocus){var results=root.querySelector('[data-nest-results]');if(!results)return Promise.resolve();results.setAttribute('aria-busy','true');return fetch(url,{headers:{'X-Requested-With':'XMLHttpRequest'}}).then(function(response){if(!response.ok)throw new Error('Unable to load articles');return response.text()}).then(function(html){var doc=new DOMParser().parseFromString(html,'text/html');var next=doc.querySelector('[data-nest-results]');if(!next)throw new Error('Article results were not found');results.innerHTML=next.innerHTML;updateFilterState(doc);if(pushState)window.history.pushState({nestBlogFilter:true},'',url);results.setAttribute('aria-busy','false');announce('Articles updated.');if(moveFocus){var heading=results.querySelector('h2');if(heading){heading.setAttribute('tabindex','-1');heading.focus()}}}).catch(function(){results.setAttribute('aria-busy','false');window.location.assign(url)})}
function revealCards(grid){var hidden=grid.querySelectorAll('.nest-blog-card--hidden');var cards=Array.prototype.slice.call(hidden,0,12);cards.forEach(function(card){card.classList.remove('nest-blog-card--hidden')});return{count:cards.length,hasMore:!!grid.querySelector('.nest-blog-card--hidden')}}
root.addEventListener('click',function(event){var filter=event.target.closest('[data-nest-filter]');if(filter&&root.contains(filter)){event.preventDefault();loadResults(filter.href,true,true);return}var button=event.target.closest('[data-nest-load-more]');if(!button||!root.contains(button))return;var grid=root.querySelector('[data-nest-results-grid]');if(!grid)return;var revealed=revealCards(grid);if(revealed.count){announce(revealed.count+' more articles loaded.');return}var next=button.dataset.nextUrl;if(!next){button.hidden=true;return}event.preventDefault();button.disabled=true;fetch(next).then(function(response){if(!response.ok)throw new Error('Unable to load more articles');return response.text()}).then(function(html){var doc=new DOMParser().parseFromString(html,'text/html');var nextGrid=doc.querySelector('[data-nest-results-grid]');if(!nextGrid)throw new Error('Additional articles were not found');var visibleAdded=0;Array.prototype.forEach.call(nextGrid.children,function(card){if(!card.classList.contains('nest-blog-card--hidden'))visibleAdded+=1;grid.appendChild(card)});var nextButton=doc.querySelector('[data-nest-load-more]');button.dataset.nextUrl=nextButton?nextButton.dataset.nextUrl:'';var additional=revealCards(grid);announce((visibleAdded+additional.count)+' more articles loaded.');if(!grid.querySelector('.nest-blog-card--hidden')&&!button.dataset.nextUrl)button.hidden=true}).catch(function(){announce('Unable to load more articles.');button.disabled=false}).then(function(){button.disabled=false})});
window.addEventListener('popstate',function(){loadResults(window.location.href,false,false)})})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-mattress-builder-preflight"]) return;
  try {
    
window.keel = true;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-outlet-grid"]) return;
  try {
    
  if (!customElements.get('nest-outlet')) {
    class NestOutlet extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.strings = JSON.parse(this.querySelector('[data-outlet-strings]').textContent);
        this.grid = this.querySelector('[data-outlet-grid]');
        this.ack = this.querySelector('[data-outlet-ack-dialog]');
        this.priceDetails = this.querySelector('[data-outlet-price-details-dialog]');
        this.warranty = this.querySelector('[data-outlet-warranty-dialog]');
        this.success = this.querySelector('[data-outlet-success-dialog]');
        this.checkbox = this.querySelector('[data-outlet-ack-checkbox]');
        this.confirmButton = this.querySelector('[data-outlet-confirm]');
        this.busy = false;
        this.pending = null;
        this.dialogOpener = null;
        this.formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: this.dataset.currency || 'USD'});
        this.cards = Array.from(this.querySelectorAll('[data-outlet-item]'));
        this.buildFilters();
        this.updateControls();
        this.filterCards();
        const options = {signal: this.controller.signal};
        this.addEventListener('click', event => this.onClick(event), options);
        this.addEventListener('input', event => this.onInput(event), options);
        this.addEventListener('change', event => this.onChange(event), options);
        this.querySelectorAll('dialog').forEach(dialog => {
          dialog.addEventListener('cancel', event => { event.preventDefault(); if (!this.busy) this.closeDialog(dialog); }, options);
          dialog.addEventListener('close', () => this.releaseDialogScroll(), options);
          dialog.addEventListener('click', event => { if (event.target === dialog && !this.busy) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.closeDialog(dialog); } }, options);
          dialog.addEventListener('keydown', event => this.trapFocus(event, dialog), options);
        });
        requestAnimationFrame(() => this.openRequestedItem());
      }
      disconnectedCallback() {
        if (this.controller) this.controller.abort();
        this.controller = null;
        clearTimeout(this.searchTimer);
        this.releaseDialogScroll();
      }
      t(key, values = {}) {
        return Object.entries(values).reduce((text, [name, value]) => text.replaceAll('[' + name + ']', String(value)), this.strings[key] || '');
      }
      money(amount) { return this.formatter.format(amount / 100); }
      inventoryLabel(count) { return Number(count) > 50 ? '50+' : String(count); }
      announce(text) {
        let live = this.querySelector('[data-outlet-live]');
        if (!live) {
          live = document.createElement('p');
          live.className = 'nb-outlet-sr';
          live.dataset.outletLive = '';
          live.setAttribute('role','status');
          live.setAttribute('aria-live','polite');
          live.setAttribute('aria-atomic','true');
          this.append(live);
        }
        live.textContent = text;
      }
      async copyItemLink(button) {
        if (button.dataset.copying === 'true') return;
        const card = button.closest('[data-outlet-item]');
        if (!card) return;
        const url = new URL(this.dataset.productUrl,location.origin);
        url.searchParams.set('variant',card.dataset.variantId);
        url.hash = card.id;
        button.dataset.copying = 'true';
        button.setAttribute('aria-busy','true');
        try {
          let copied = false;
          if (navigator.clipboard && window.isSecureContext) {
            try { await navigator.clipboard.writeText(url.href); copied = true; } catch (error) { }
          }
          if (!copied) {
            const field = document.createElement('textarea');
            try {
              field.value = url.href;
              field.setAttribute('readonly','');
              field.className = 'nb-outlet-sr';
              document.body.append(field);
              field.select();
              copied = document.execCommand('copy');
            } finally {
              field.remove();
              button.focus({preventScroll:true});
            }
          }
          if (!copied) throw new Error('Copy command failed');
          const item = card.dataset.itemTitle;
          const tooltip = button.querySelector('[data-outlet-copy-tooltip]');
          const defaultLabel = button.dataset.outletCopyDefaultLabel;
          button.dataset.copied = 'true';
          button.setAttribute('aria-label',this.t('copiedMessage',{item}));
          button.title = this.t('copiedMessage',{item});
          if (tooltip) tooltip.textContent = this.t('linkCopied');
          this.announce(this.t('copiedMessage',{item}));
          clearTimeout(button.copyResetTimer);
          button.copyResetTimer = setTimeout(() => {
            button.dataset.copied = 'false';
            button.setAttribute('aria-label',defaultLabel);
            button.title = defaultLabel;
            if (tooltip) tooltip.textContent = this.t('copyLink');
          },2400);
        } catch (error) {
          console.error('[Nest outlet] Copy link failed',{error,variantId:card.dataset.variantId});
          this.announce(this.t('copyFailed'));
        } finally {
          delete button.dataset.copying;
          button.removeAttribute('aria-busy');
        }
      }
      statusFor(card) {
        let status = card.querySelector('[data-outlet-item-status]');
        if (status) return status;
        status = document.createElement('p');
        status.className = 'nb-outlet-card__status';
        status.id = 'OutletStatus-' + card.dataset.variantId;
        status.dataset.outletItemStatus = '';
        const purchase = card.querySelector('.nb-outlet-card__purchase');
        if (purchase) purchase.prepend(status);
        const select = card.querySelector('[data-outlet-select]');
        if (select) select.setAttribute('aria-describedby',status.id);
        return status;
      }
      getCard(id) { return this.cards.find(card => card.dataset.variantId === String(id)); }
      snapshot(card, root = this) {
        return {
          id: card.dataset.variantId,
          title: card.dataset.itemTitle,
          price: Number(card.dataset.price),
          inventory: Number(card.dataset.inventory),
          ready: card.dataset.ready === 'true' && root.dataset.policyReady === 'true',
          period: card.dataset.warranty,
          summary: card.dataset.warrantySummary,
          details: card.dataset.warrantyDetails,
          shipping: card.dataset.shipping,
          condition: card.dataset.condition,
          sku: card.dataset.sku,
          policy: root.dataset.policyVersion,
          acknowledgment: root.querySelector('[data-outlet-ack-text]').textContent,
          policySummary: root.querySelector('.nb-outlet-policy p').textContent,
          policyHTML: root.querySelector('[data-outlet-policy-body]').innerHTML,
          currency: root.dataset.currency
        };
      }
      signature(item) {
        return JSON.stringify([item.id,item.title,item.price,item.period,item.summary,item.details,item.shipping,item.condition,item.sku,item.policy,item.acknowledgment,item.policySummary,item.policyHTML,item.currency,item.ready]);
      }
      buildFilters() {
        this.querySelectorAll('[data-outlet-filters] input,[data-outlet-filters] select').forEach(control => { control.disabled = false; });
      }
      filterCards() {
        const search = this.querySelector('[data-outlet-search]').value.trim().toLocaleLowerCase();
        const filters = Array.from(this.querySelectorAll('[data-outlet-filter]'));
        let visible = 0;
        let total = 0;
        this.cards.forEach(card => {
          const inStock = Number(card.dataset.inventory) > 0;
          if (inStock) total++;
          const text = [card.dataset.itemTitle,card.dataset.brand,card.dataset.category,card.dataset.size,card.dataset.sku,card.textContent].join(' ').toLocaleLowerCase();
          const match = (!search || text.includes(search)) && filters.every(select => !select.value || card.dataset[select.dataset.outletFilter] === select.value);
          card.hidden = !match || (!inStock && card.dataset.pinned !== 'true');
          if (match && inStock) visible++;
        });
        const filtered = Boolean(search || filters.some(select => select.value));
        this.querySelector('[data-outlet-count]').textContent = filtered ? this.t('filteredCount',{visible,total}) : this.t('listingCount',{count:total});
        this.querySelector('[data-outlet-empty]').hidden = total > 0;
        this.querySelector('[data-outlet-no-results]').hidden = visible > 0 || total === 0;
        this.querySelectorAll('[data-outlet-reset]').forEach(button => { if (!button.closest('[data-outlet-no-results]')) button.hidden = !filtered; });
      }
      sortCards() {
        const sort = this.querySelector('[data-outlet-sort]').value;
        this.cards.sort((a,b) => sort === 'title' ? a.dataset.itemTitle.localeCompare(b.dataset.itemTitle) : sort === 'price-ascending' ? Number(a.dataset.price)-Number(b.dataset.price) : sort === 'price-descending' ? Number(b.dataset.price)-Number(a.dataset.price) : Number(a.dataset.position)-Number(b.dataset.position));
        this.grid.append(...this.cards);
      }
      updateControls() {
        this.cards.forEach(card => {
          const ready = card.dataset.ready === 'true' && this.dataset.policyReady === 'true' && Number(card.dataset.inventory) > 0 && Number(card.dataset.allowance ?? card.dataset.inventory) > 0;
          const input = card.querySelector('[data-outlet-quantity-input]');
          input.disabled = !ready || this.busy;
          card.querySelector('[data-outlet-select]').disabled = !ready || this.busy;
          card.querySelectorAll('[data-outlet-quantity-change]').forEach(button => {
            const value = Number(input.value);
            button.disabled = !ready || this.busy || (button.dataset.outletQuantityChange === '-1' ? value <= 1 : value >= Number(input.max));
          });
        });
        this.querySelectorAll('[data-outlet-close]').forEach(button => { button.disabled = this.busy; });
        this.checkbox.disabled = this.busy;
        this.confirmButton.disabled = this.busy || !this.checkbox.checked || !this.pending || !this.pending.ready || this.pending.blocked;
      }
      setBusy(value) { this.busy = value; this.ack.setAttribute('aria-busy', String(value)); this.updateControls(); }
      onInput(event) {
        if (event.target.matches('[data-outlet-search]')) {
          clearTimeout(this.searchTimer);
          this.searchTimer = setTimeout(() => this.filterCards(), 120);
        }
        if (event.target.matches('[data-outlet-quantity-input]')) this.updateControls();
      }
      onChange(event) {
        if (event.target.matches('[data-outlet-filter]')) { this.cards.forEach(card => { delete card.dataset.pinned; }); this.filterCards(); }
        if (event.target.matches('[data-outlet-sort]')) this.sortCards();
        if (event.target === this.checkbox) this.updateControls();
        if (event.target.matches('[data-outlet-quantity-input]')) this.validateQuantity(event.target.closest('[data-outlet-item]'));
      }
      onClick(event) {
        const control = event.target.closest('button,a');
        if (!control || !this.contains(control)) return;
        if (control.matches('[data-outlet-copy-link]')) {
          this.copyItemLink(control);
        } else if (control.matches('[data-outlet-quantity-change]')) {
          const card = control.closest('[data-outlet-item]');
          const input = card.querySelector('[data-outlet-quantity-input]');
          input.value = String(Math.max(1,Math.min(Number(input.max), (Number(input.value) || 1) + Number(control.dataset.outletQuantityChange))));
          this.updateControls();
        } else if (control.matches('[data-outlet-select]')) {
          this.selectItem(control.closest('[data-outlet-item]'), control);
        } else if (control.matches('[data-outlet-confirm]')) {
          this.confirmItem();
        } else if (control.matches('[data-outlet-close]')) {
          if (!this.busy) this.closeDialog(control.closest('dialog'));
        } else if (control.matches('[data-outlet-price-details-open]')) {
          this.openDialog(this.priceDetails, control);
        } else if (control.matches('[data-outlet-policy-open],[data-outlet-warranty-open]')) {
          this.openWarranty(control.closest('[data-outlet-item]'), control);
        } else if (control.matches('[data-outlet-reset]')) {
          this.querySelector('[data-outlet-search]').value = '';
          this.querySelectorAll('[data-outlet-filter]').forEach(select => { select.value = ''; });
          this.cards.forEach(card => { delete card.dataset.pinned; });
          this.filterCards();
          this.querySelector('[data-outlet-search]').focus();
        }
      }
      validateQuantity(card) {
        const input = card.querySelector('[data-outlet-quantity-input]');
        const quantity = Number(input.value);
        const valid = Number.isInteger(quantity) && quantity >= 1 && quantity <= Number(input.max);
        const status = this.statusFor(card);
        if (!valid) {
          input.setAttribute('aria-invalid','true');
          input.setAttribute('aria-describedby',status.id);
          status.textContent = this.t('quantityInvalid',{count:input.max});
          this.announce(status.textContent);
        } else {
          input.removeAttribute('aria-invalid');
          if (card.dataset.ready === 'true') status.textContent = '';
        }
        return valid ? quantity : null;
      }
      openDialog(dialog, opener) {
        if (typeof dialog.showModal !== 'function') {
          this.announce(this.t('checkFailed'));
          return;
        }
        const root = document.documentElement;
        const scrollbarWidth = Math.max(0, window.innerWidth - root.clientWidth);
        this.dialogOpener = opener;
        dialog.showModal();
        if (!root.classList.contains('nb-outlet-dialog-open')) {
          root.style.setProperty('--nb-outlet-scrollbar-width', scrollbarWidth + 'px');
          root.classList.add('nb-outlet-dialog-open');
        }
        dialog.querySelector('[data-outlet-close]').focus({preventScroll:true});
      }
      closeDialog(dialog, restore = true) {
        dialog.close();
        queueMicrotask(() => this.releaseDialogScroll());
        if (restore && this.dialogOpener && this.dialogOpener.isConnected) this.dialogOpener.focus({preventScroll:true});
        if (dialog === this.ack) {
          this.pending = null;
          this.checkbox.checked = false;
          this.confirmButton.disabled = true;
        }
      }
      releaseDialogScroll() {
        if (!document.querySelector('nest-outlet dialog[open]')) {
          document.documentElement.classList.remove('nb-outlet-dialog-open');
          document.documentElement.style.removeProperty('--nb-outlet-scrollbar-width');
        }
      }
      trapFocus(event, dialog) {
        if (event.key !== 'Tab') return;
        const focusable = Array.from(dialog.querySelectorAll('button:not(:disabled),a[href],input:not(:disabled),summary,[tabindex="0"]')).filter(element => !element.hidden && element.getClientRects().length);
        if (!focusable.length) { event.preventDefault(); return; }
        const first = focusable[0], last = focusable[focusable.length-1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
      openWarranty(card, opener) {
        const item = card ? this.snapshot(card) : null;
        this.querySelector('[data-outlet-warranty-heading]').textContent = item ? item.title : this.t('warrantyTitle');
        const summary = this.querySelector('[data-outlet-warranty-summary]');
        summary.replaceChildren();
        summary.hidden = !item;
        if (item) {
          [item.period ? this.t('coverage') + ': ' + item.period : '',item.summary,item.details].filter(Boolean).forEach(text => { const p = document.createElement('p'); p.textContent = text; summary.append(p); });
        }
        this.querySelector('[data-outlet-warranty-body]').replaceChildren(this.querySelector('[data-outlet-policy-body]').cloneNode(true));
        this.openDialog(this.warranty,opener);
      }
      openRequestedItem() {
        const id = new URL(location.href).searchParams.get('variant');
        if (!id) return;
        const card = this.getCard(id);
        if (card) { card.scrollIntoView({block:'start',behavior:'instant'}); card.focus({preventScroll:true}); }
        else {
          const notice = this.querySelector('[data-outlet-requested-message]');
          notice.hidden = false;
          notice.textContent = this.t('requestedUnavailable');
          notice.focus();
        }
      }
      async fetchJSON(url, options = {}) {
        const response = await fetch(url,{credentials:'same-origin',cache:'no-store',...options});
        const data = await response.json();
        if (!response.ok) { const error = new Error(data.description || data.message || this.t('checkFailed')); error.status = response.status; throw error; }
        return data;
      }
      async preflight(id) {
        const url = new URL(this.dataset.productUrl,location.origin);
        url.searchParams.set('section_id',this.dataset.sectionId);
        url.searchParams.set('_outlet_check',String(Date.now()));
        const [response,cart] = await Promise.all([
          fetch(url,{credentials:'same-origin',cache:'no-store'}),
          this.fetchJSON(this.dataset.rootUrl + 'cart.js')
        ]);
        if (!response.ok) throw new Error(this.t('checkFailed'));
        const documentCopy = new DOMParser().parseFromString(await response.text(),'text/html');
        const root = documentCopy.querySelector('nest-outlet');
        if (!root) throw new Error(this.t('checkFailed'));
        const card = Array.from(root.querySelectorAll('[data-outlet-item]')).find(element => element.dataset.variantId === id);
        if (!card) return {item:null,cart};
        const item = this.snapshot(card,root);
        const inCart = cart.items.filter(line => String(line.variant_id) === id).reduce((sum,line) => sum + Number(line.quantity),0);
        return {item,card,cart,remaining:Math.max(0,item.inventory-inCart),inCart};
      }
      refreshCard(fresh, previous) {
        const currentQuantity = previous.querySelector('[data-outlet-quantity-input]').value;
        const replacement = document.importNode(fresh,true);
        replacement.querySelector('[data-outlet-quantity-input]').value = currentQuantity;
        if (previous.contains(this.dialogOpener)) this.dialogOpener = replacement.querySelector('[data-outlet-select]');
        previous.replaceWith(replacement);
        this.cards[this.cards.indexOf(previous)] = replacement;
        this.updateControls();
        this.filterCards();
        return replacement;
      }
      syncAvailability(card, item, remaining) {
        card.dataset.inventory = String(item.inventory);
        card.dataset.allowance = String(remaining);
        card.querySelector('[data-outlet-stock]').textContent = this.t('remaining',{count:this.inventoryLabel(item.inventory)});
        card.querySelector('[data-outlet-quantity-input]').max = String(Math.max(1,remaining));
        this.updateControls();
      }
      markSoldOut(card) {
        card.dataset.inventory = '0';
        card.dataset.ready = 'false';
        card.dataset.soldOut = 'true';
        card.dataset.pinned = 'true';
        card.querySelector('[data-outlet-stock]').textContent = this.t('soldOut');
        card.querySelector('[data-outlet-select]').textContent = this.t('soldOut');
        this.statusFor(card).textContent = this.t('unavailable');
        this.updateControls();
        this.filterCards();
      }
      async selectItem(card, opener) {
        if (this.busy || card.dataset.ready !== 'true' || this.dataset.policyReady !== 'true') return;
        const quantity = this.validateQuantity(card);
        if (quantity === null) { card.querySelector('input').focus(); return; }
        this.setBusy(true);
        opener.textContent = this.t('checking');
        const status = this.statusFor(card);
        status.textContent = this.t('checking');
        try {
          const fresh = await this.preflight(card.dataset.variantId);
          if (!this.isConnected) return;
          if (!fresh.item) { this.markSoldOut(card); this.announce(this.t('unavailable')); return; }
          if (this.signature(fresh.item) !== this.signature(this.snapshot(card))) {
            card = this.refreshCard(fresh.card,card);
            opener = card.querySelector('[data-outlet-select]');
          }
          this.syncAvailability(card,fresh.item,fresh.remaining);
          if (!fresh.item.ready) { this.announce(this.statusFor(card).textContent); return; }
          if (!fresh.remaining) { this.statusFor(card).textContent = this.t('inCart'); this.announce(this.t('inCart')); return; }
          if (quantity > fresh.remaining) {
            const input = card.querySelector('[data-outlet-quantity-input]');
            input.max = String(fresh.remaining);
            this.statusFor(card).textContent = this.t('quantityInvalid',{count:fresh.remaining});
            input.setAttribute('aria-invalid','true');
            this.announce(this.statusFor(card).textContent);
            return;
          }
          this.pending = {...fresh.item,quantity};
          this.fillAcknowledgment();
          this.statusFor(card).textContent = '';
          this.setBusy(false);
          this.openDialog(this.ack,opener);
        } catch (error) {
          console.error('[Nest outlet] Item detail preflight failed', {
            error,
            variantId: card && card.dataset ? card.dataset.variantId : null,
            item: card ? this.snapshot(card) : null
          });
          if (this.isConnected) { this.statusFor(card).textContent = this.t('checkFailed'); this.announce(this.t('checkFailed')); }
        } finally {
          if (this.isConnected) { this.setBusy(false); if (card.dataset.soldOut !== 'true') opener.textContent = this.t('add'); }
        }
      }
      fillAcknowledgment() {
        const item = this.pending;
        this.querySelector('[data-outlet-ack-item]').textContent = item.title;
        this.querySelector('[data-outlet-ack-quantity]').textContent = String(item.quantity);
        this.querySelector('[data-outlet-ack-total]').textContent = this.money(item.price*item.quantity);
        this.querySelector('[data-outlet-ack-warranty]').textContent = [item.period,item.summary].filter(Boolean).join('. ');
        this.querySelector('[data-outlet-ack-shipping]').textContent = item.shipping;
        this.querySelector('[data-outlet-ack-text]').textContent = item.acknowledgment;
        const policy = new DOMParser().parseFromString(item.policyHTML,'text/html');
        const container = this.querySelector('[data-outlet-ack-policy]');
        container.replaceChildren();
        if (item.details) { const p = document.createElement('p'); p.textContent = item.details; container.append(p); }
        container.append(...Array.from(policy.body.childNodes));
        this.querySelector('.nb-outlet-ack-terms').open = false;
        this.querySelector('[data-outlet-ack-message]').textContent = '';
        this.checkbox.checked = false;
        this.confirmButton.textContent = this.t('confirm');
        this.updateControls();
      }
      async confirmItem() {
        if (this.busy || !this.pending || !this.pending.ready || this.pending.blocked || !this.checkbox.checked) return;
        const accepted = {...this.pending};
        const card = this.getCard(accepted.id);
        const message = this.querySelector('[data-outlet-ack-message]');
        let mutationStarted = false;
        this.setBusy(true);
        this.confirmButton.textContent = this.t('checking');
        message.textContent = this.t('checking');
        try {
          const fresh = await this.preflight(accepted.id);
          if (!this.isConnected) return;
          if (!fresh.item || !fresh.item.ready || !fresh.remaining) {
            this.pending.blocked = true;
            if (!fresh.item) this.markSoldOut(card);
            else if (!fresh.item.ready) this.refreshCard(fresh.card,card);
            this.checkbox.checked = false;
            message.textContent = fresh.item && !fresh.remaining ? this.t('inCart') : this.t('unavailable');
            return;
          }
          if (this.signature(accepted) !== this.signature(fresh.item) || accepted.quantity > fresh.remaining) {
            const replacement = this.refreshCard(fresh.card,card);
            this.syncAvailability(replacement,fresh.item,fresh.remaining);
            this.pending = {...fresh.item,quantity:Math.min(accepted.quantity,fresh.remaining)};
            this.fillAcknowledgment();
            message.textContent = this.t('changed');
            return;
          }
          const properties = {
            'Outlet item': accepted.title,
            'Final sale': 'Acknowledged',
            'Outlet warranty': accepted.period,
            '_Outlet policy version': accepted.policy,
            '_Outlet item name': accepted.title,
            '_Outlet warranty period': accepted.period,
            '_Outlet acknowledgment': accepted.acknowledgment,
            '_Outlet shipping note': accepted.shipping,
            '_Outlet condition': accepted.condition
          };
          if (accepted.summary) properties['_Outlet warranty summary'] = accepted.summary;
          mutationStarted = true;
          this.confirmButton.textContent = this.t('adding');
          message.textContent = this.t('adding');
          const result = await this.fetchJSON(this.dataset.rootUrl + 'cart/add.js',{
            method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({items:[{id:accepted.id,quantity:accepted.quantity,properties}]})
          });
          if (!this.isConnected) return;
          const added = result.items && result.items.find(line => String(line.variant_id || line.id) === accepted.id);
          if (!added) throw new Error(this.t('uncertain'));
          const opener = this.dialogOpener;
          this.closeDialog(this.ack,false);
          this.setBusy(false);
          this.querySelector('[data-outlet-success-text]').textContent = this.t('added',{quantity:accepted.quantity,item:accepted.title});
          this.announce(this.t('added',{quantity:accepted.quantity,item:accepted.title}));
          const cartTrigger = document.querySelector('.site-header__cart');
          const cartModal = document.querySelector('.cart-modal');
          if (typeof window.UpdateCart === 'function') window.UpdateCart();
          ['cart:refresh','refreshCart','refreshAjaxCart'].forEach(name => window.dispatchEvent(new CustomEvent(name,{detail:{source:'outlet'}})));
          if (cartTrigger && cartModal) {
            cartTrigger.click();
          } else {
            this.openDialog(this.success,opener);
          }
          try {
            const cart = await this.fetchJSON(this.dataset.rootUrl+'cart.js');
            const current = this.getCard(accepted.id);
            const inCart = cart.items.filter(line => String(line.variant_id) === accepted.id).reduce((sum,line) => sum + Number(line.quantity),0);
            this.syncAvailability(current,fresh.item,Math.max(0,fresh.item.inventory-inCart));
            if (inCart >= fresh.item.inventory) this.statusFor(current).textContent = this.t('inCart');
            document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = String(cart.item_count); });
            document.querySelectorAll('[data-cart-count-bubble]').forEach(node => { node.classList.toggle('hide',cart.item_count === 0); });
          } catch (error) { }
        } catch (error) {
          if (!this.isConnected) return;
          this.checkbox.checked = false;
          if (mutationStarted && (!error.status || error.status >= 500)) {
            this.pending.blocked = true;
            message.textContent = this.t('uncertain');
            const link = document.createElement('a');
            link.href = this.dataset.cartUrl;
            link.textContent = this.success.querySelector('[data-outlet-view-cart]').textContent;
            message.append(' ',link);
          } else {
            message.textContent = mutationStarted ? this.t('addFailed') : this.t('checkFailed');
          }
          this.announce(message.textContent);
        } finally {
          if (this.isConnected) { this.setBusy(false); this.confirmButton.textContent = this.t('confirm'); }
        }
      }
    }
    customElements.define('nest-outlet',NestOutlet);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews-html-all"]) return;
  try {
    
(function () {
  var root = document.getElementById('shopify-section-product-reviews-html-all');
  function normalize(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function textNodes(element) {
    if (!element || !document.createTreeWalker) return [];
    var walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    var nodes = [];
    var node;
    while ((node = walker.nextNode())) nodes.push(node);
    return nodes;
  }

  function directChildWithin(element, child) {
    var current = child;
    while (current && current.parentElement && current.parentElement !== element) {
      current = current.parentElement;
    }
    return current && current.parentElement === element ? current : null;
  }

  function tagNestologistReplies(grid) {
    textNodes(grid).forEach(function (node) {
      if (normalize(node.nodeValue) !== 'Nest Bedding') return;
      var label = node.parentElement;
      if (!label) return;

      var container = label.parentElement;
      var depth = 0;
      while (container && container !== grid && depth < 6) {
        var icon = container.querySelector('svg:not(.bird-image), img');
        if (icon) {
          icon.classList.add('nest-review-nestologist-icon');
          var iconBranch = directChildWithin(container, icon);
          var labelBranch = directChildWithin(container, label);
          if (iconBranch && labelBranch && iconBranch !== labelBranch) {
            iconBranch.classList.add('nest-review-nestologist-icon-wrap');
          }
          return;
        }
        container = container.parentElement;
        depth += 1;
      }
    });
  }

  function watchGrid(grid) {
    if (!grid || grid.getAttribute('data-nest-customer-review-icons') === 'v1') return;
    grid.setAttribute('data-nest-customer-review-icons', 'v1');
    tagNestologistReplies(grid);
    if (!window.MutationObserver) return;

    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        tagNestologistReplies(grid);
      });
    }).observe(grid, { childList: true, subtree: true });
  }

  function init() {
    if (!root) return;
    watchGrid(root.querySelector('.reviews-grid'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews-html-backup-20260818"]) return;
  try {
    
(function () {
  var ratingLabelPattern = /^(Quality|Comfort) Rate:?$/i;
  var ratingValuePattern = /^([0-5])(?:\.0)?$/;
  var customerNameExclusions = /^(Nest Bedding|Verified Buyer|Weight|Firmness|Quality Rate|Comfort Rate|Type of Sleeper\(s\)|Medium|Firm|Plush|Normal|Back Sleeper|Side Sleeper|Stomach Sleeper|Combination Sleeper)$/i;
  var observers = [];

  function normalize(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function textNodes(root) {
    if (!root || !document.createTreeWalker) return [];
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var nodes = [];
    var node;
    while ((node = walker.nextNode())) nodes.push(node);
    return nodes;
  }

  function formatRatings(grid) {
    var nodes = textNodes(grid);
    nodes.forEach(function (labelNode, index) {
      if (!ratingLabelPattern.test(normalize(labelNode.nodeValue))) return;
      for (var offset = 1; offset <= 8 && index + offset < nodes.length; offset += 1) {
        var valueNode = nodes[index + offset];
        var value = normalize(valueNode.nodeValue);
        var match = value.match(ratingValuePattern);
        if (match) {
          valueNode.nodeValue = valueNode.nodeValue.replace(value, match[1] + ' out of 5');
          return;
        }
        if (ratingLabelPattern.test(value) || /:$/.test(value)) return;
      }
    });
  }

  function directChildWithin(root, element) {
    var current = element;
    while (current && current.parentElement && current.parentElement !== root) current = current.parentElement;
    return current && current.parentElement === root ? current : null;
  }

  function tagNestologistReplies(grid) {
    textNodes(grid).forEach(function (node) {
      if (normalize(node.nodeValue) !== 'Nest Bedding') return;
      var label = node.parentElement;
      if (!label) return;
      label.classList.add('nest-review-brand-name');

      var container = label.parentElement;
      var depth = 0;
      while (container && container !== grid && depth < 6) {
        var icon = container.querySelector('svg:not(.bird-image), img');
        if (icon) {
          icon.classList.add('nest-review-nestologist-icon');
          var iconBranch = directChildWithin(container, icon);
          var labelBranch = directChildWithin(container, label);
          if (iconBranch && labelBranch && iconBranch !== labelBranch) {
            iconBranch.classList.add('nest-review-nestologist-icon-wrap');
          }
          return;
        }
        container = container.parentElement;
        depth += 1;
      }
    });
  }

  function isCustomerName(value) {
    if (!value || value.length > 60 || /:/.test(value)) return false;
    if (customerNameExclusions.test(value)) return false;
    if (/^\d|\d{4}$|out of 5/i.test(value)) return false;
    return /[A-Za-z]/.test(value);
  }

  function removeIfEmpty(element) {
    if (!element || element.classList.contains('nest-review-author-stack')) return;
    if (!normalize(element.textContent) && element.children.length === 0 && element.parentNode) {
      element.parentNode.removeChild(element);
    }
  }

  function groupCustomerAuthors(grid) {
    Array.prototype.forEach.call(grid.querySelectorAll('.bird-image'), function (icon) {
      if (icon.closest('.nest-review-author-stack')) return;

      var container = icon.parentElement;
      var depth = 0;
      var nameNode = null;
      var nameElement = null;

      while (container && container !== grid && depth < 6 && !nameNode) {
        var nodes = textNodes(container);
        for (var index = 0; index < nodes.length; index += 1) {
          var candidate = nodes[index];
          var value = normalize(candidate.nodeValue);
          var followsIcon = icon.compareDocumentPosition(candidate) & Node.DOCUMENT_POSITION_FOLLOWING;
          if (followsIcon && isCustomerName(value)) {
            nameNode = candidate;
            nameElement = candidate.parentElement;
            break;
          }
        }
        if (!nameNode) {
          container = container.parentElement;
          depth += 1;
        }
      }

      if (!nameElement) return;
      nameElement.classList.add('nest-review-customer-name');

      var identity = nameElement.parentElement;
      while (identity && identity !== grid && !identity.contains(icon)) identity = identity.parentElement;
      if (!identity || identity === grid) return;

      var iconBranch = directChildWithin(identity, icon);
      var nameBranch = directChildWithin(identity, nameElement);
      if (!iconBranch || !nameBranch || iconBranch === nameBranch) return;
      if (normalize(iconBranch.textContent)) return;

      var stack = document.createElement('div');
      stack.className = 'nest-review-author-stack';
      identity.insertBefore(stack, iconBranch);
      stack.appendChild(iconBranch);
      stack.appendChild(nameElement);
      removeIfEmpty(nameBranch);
    });
  }

  function formatReviewCards(grid) {
    if (!grid) return;
    formatRatings(grid);
    tagNestologistReplies(grid);
    groupCustomerAuthors(grid);
  }

  function watchGrid(grid) {
    if (!grid || grid.getAttribute('data-nest-review-format') === 'v3') return;
    grid.setAttribute('data-nest-review-format', 'v3');
    formatReviewCards(grid);
    if (!window.MutationObserver) return;

    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        formatReviewCards(grid);
      });
    });

    observer.observe(grid, { childList: true, subtree: true });
    observers.push(observer);
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.reviews-grid'), watchGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews-html"]) return;
  try {
    
(function () {
  var ratingLabelPattern = /^(Quality|Comfort) Rate:?$/i;
  var ratingValuePattern = /^([0-5])(?:\.0)?$/;
  var customerNameExclusions = /^(Nest Bedding|Verified Buyer|Weight|Firmness|Quality Rate|Comfort Rate|Type of Sleeper\(s\)|Medium|Firm|Plush|Normal|Back Sleeper|Side Sleeper|Stomach Sleeper|Combination Sleeper)$/i;
  var observers = [];

  function normalize(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function textNodes(root) {
    if (!root || !document.createTreeWalker) return [];
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var nodes = [];
    var node;
    while ((node = walker.nextNode())) nodes.push(node);
    return nodes;
  }

  function formatRatings(grid) {
    var nodes = textNodes(grid);
    nodes.forEach(function (labelNode, index) {
      if (!ratingLabelPattern.test(normalize(labelNode.nodeValue))) return;
      for (var offset = 1; offset <= 8 && index + offset < nodes.length; offset += 1) {
        var valueNode = nodes[index + offset];
        var value = normalize(valueNode.nodeValue);
        var match = value.match(ratingValuePattern);
        if (match) {
          valueNode.nodeValue = valueNode.nodeValue.replace(value, match[1] + ' out of 5');
          return;
        }
        if (ratingLabelPattern.test(value) || /:$/.test(value)) return;
      }
    });
  }

  function directChildWithin(root, element) {
    var current = element;
    while (current && current.parentElement && current.parentElement !== root) current = current.parentElement;
    return current && current.parentElement === root ? current : null;
  }

  function tagNestologistReplies(grid) {
    textNodes(grid).forEach(function (node) {
      if (normalize(node.nodeValue) !== 'Nest Bedding') return;
      var label = node.parentElement;
      if (!label) return;
      label.classList.add('nest-review-brand-name');

      var container = label.parentElement;
      var depth = 0;
      while (container && container !== grid && depth < 6) {
        var icon = container.querySelector('svg:not(.bird-image), img');
        if (icon) {
          icon.classList.add('nest-review-nestologist-icon');
          var iconBranch = directChildWithin(container, icon);
          var labelBranch = directChildWithin(container, label);
          if (iconBranch && labelBranch && iconBranch !== labelBranch) {
            iconBranch.classList.add('nest-review-nestologist-icon-wrap');
          }
          return;
        }
        container = container.parentElement;
        depth += 1;
      }
    });
  }

  function isCustomerName(value) {
    if (!value || value.length > 60 || /:/.test(value)) return false;
    if (customerNameExclusions.test(value)) return false;
    if (/^\d|\d{4}$|out of 5/i.test(value)) return false;
    return /[A-Za-z]/.test(value);
  }

  function removeIfEmpty(element) {
    if (!element || element.classList.contains('nest-review-author-stack')) return;
    if (!normalize(element.textContent) && element.children.length === 0 && element.parentNode) {
      element.parentNode.removeChild(element);
    }
  }

  function groupCustomerAuthors(grid) {
    Array.prototype.forEach.call(grid.querySelectorAll('.bird-image'), function (icon) {
      if (icon.closest('.nest-review-author-stack')) return;

      var container = icon.parentElement;
      var depth = 0;
      var nameNode = null;
      var nameElement = null;

      while (container && container !== grid && depth < 6 && !nameNode) {
        var nodes = textNodes(container);
        for (var index = 0; index < nodes.length; index += 1) {
          var candidate = nodes[index];
          var value = normalize(candidate.nodeValue);
          var followsIcon = icon.compareDocumentPosition(candidate) & Node.DOCUMENT_POSITION_FOLLOWING;
          if (followsIcon && isCustomerName(value)) {
            nameNode = candidate;
            nameElement = candidate.parentElement;
            break;
          }
        }
        if (!nameNode) {
          container = container.parentElement;
          depth += 1;
        }
      }

      if (!nameElement) return;
      nameElement.classList.add('nest-review-customer-name');

      var identity = nameElement.parentElement;
      while (identity && identity !== grid && !identity.contains(icon)) identity = identity.parentElement;
      if (!identity || identity === grid) return;

      var iconBranch = directChildWithin(identity, icon);
      var nameBranch = directChildWithin(identity, nameElement);
      if (!iconBranch || !nameBranch || iconBranch === nameBranch) return;
      if (normalize(iconBranch.textContent)) return;

      var stack = document.createElement('div');
      stack.className = 'nest-review-author-stack';
      identity.insertBefore(stack, iconBranch);
      stack.appendChild(iconBranch);
      stack.appendChild(nameElement);
      removeIfEmpty(nameBranch);
    });
  }

  var reviewSvgSequence = 0;

  function uniquifyReviewSvgIds(grid) {
    Array.prototype.forEach.call(
      grid.querySelectorAll('svg:not([data-nest-review-svg-ids])'),
      function (svg) {
        svg.setAttribute('data-nest-review-svg-ids', 'true');
        var idMap = {};
        reviewSvgSequence += 1;
        var prefix = 'nest-pdp-review-svg-' + reviewSvgSequence + '-';

        Array.prototype.forEach.call(svg.querySelectorAll('[id]'), function (element) {
          var oldId = element.id;
          var newId = prefix + oldId;
          idMap[oldId] = newId;
          element.id = newId;
        });

        Array.prototype.forEach.call(svg.querySelectorAll('*'), function (element) {
          Array.prototype.forEach.call(element.attributes || [], function (attribute) {
            var value = attribute.value;
            Object.keys(idMap).forEach(function (oldId) {
              value = value.split('#' + oldId).join('#' + idMap[oldId]);
            });
            if (attribute.name === 'aria-labelledby' || attribute.name === 'aria-describedby') {
              value = value.split(/\s+/).map(function (token) {
                return idMap[token] || token;
              }).join(' ');
            }
            if (value !== attribute.value) element.setAttribute(attribute.name, value);
          });
        });
      }
    );
  }

  function formatReviewCards(grid) {
    if (!grid) return;
    uniquifyReviewSvgIds(grid);
    formatRatings(grid);
    tagNestologistReplies(grid);
    groupCustomerAuthors(grid);
  }

  function watchGrid(grid) {
    if (!grid || grid.getAttribute('data-nest-review-format') === 'v3') return;
    grid.setAttribute('data-nest-review-format', 'v3');
    formatReviewCards(grid);
    if (!window.MutationObserver) return;

    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        formatReviewCards(grid);
      });
    });

    observer.observe(grid, { childList: true, subtree: true });
    observers.push(observer);
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.reviews-grid'), watchGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["refer-a-friend-hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = 'impact-embed[data-raf-impact]';
    const frameTitle = 'Nest Bedding refer-a-friend signup and sharing form';
    const observedRoots = new WeakSet();

    const titleFrame = (embed) => {
      const root = embed.shadowRoot || embed;
      const frame = root.querySelector('#squatchFrame, iframe');

      if (!frame) return false;

      frame.setAttribute('title', frameTitle);

      if (!observedRoots.has(root)) {
        const observer = new MutationObserver(() => titleFrame(embed));
        observer.observe(root, { childList: true, subtree: true });
        observedRoots.add(root);
      }

      return true;
    };

    const watchEmbed = (embed) => {
      if (embed.dataset.rafTitleWatch === 'true') return;
      embed.dataset.rafTitleWatch = 'true';

      let attempts = 0;
      const timer = window.setInterval(() => {
        attempts += 1;

        if (titleFrame(embed) || attempts >= 80) {
          window.clearInterval(timer);
        }
      }, 250);
    };

    const initialize = (root = document) => {
      if (root.matches && root.matches(selector)) watchEmbed(root);
      root.querySelectorAll(selector).forEach(watchEmbed);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shops-map"]) return;
  try {
    
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.showrooms__map .state .close');
  if (!btn) return;
  if (typeof closePopup === 'function') {
    closePopup();
  } else {
    var panel = btn.closest('.state');
    if (panel) panel.classList.add('hide');
  }
  btn.blur();
});

  } catch(e) { console.error(e); }
})();
})();
